// Export
module.exports =
{
  // Search scripts
  search:
  {

      // Method-wide scripts
      _init: function ()
      {
        APPLICATION._APPLICATION.load($('#submissions'), APPLICATION._PATH_PREFIX + 'signups/developments', 'Signups', 'developments')
      }

  },
  signups:
  {
      _init: function ()
      {
        var development_id = $('#submissions').data('development');
        APPLICATION._APPLICATION.load($('#submissions'), APPLICATION._PATH_PREFIX + 'signups/signup-data/'+development_id, 'Signups', 'developments', function(){
          $('.datepicker').not('.js-ignore').on('blur', function(){
            // get the input group
           // @TODO set the date picked event to update the server and the markup
          }).datepicker({
            format: 'yyyy-mm-dd'
          }).on('changeDate', function(){
            var $this = $(this);
            var applicationId = $this.parents('tr').attr('data-a-id');
            var data = encodeURIComponent('id') + '=' + applicationId + '&';
            data += encodeURIComponent('date') + '=' + $this.val();
            $this.siblings('.input-group-addon').html('<i class="glyphicon glyphicon glyphicon-repeat gly-spin"></i>');
            var jqxhr = $.ajax({
              type: 'post',
              url: '/signups/offer-date',
              data: data
            }).done(function(data){
              if(data.status) {
                $this.siblings('.input-group-addon').html('<i class="glyphicon glyphicon glyphicon-ok"></i>');
              }
              else {
                $this.siblings('.input-group-addon').html('<i class="glyphicon glyphicon-remove"></i>');
              }
            })
              .fail(function(){
                $this.siblings('.input-group-addon').html('');
              });
          }).addClass('js-ignore');
        });
      }
  }
}